import { combineReducers, Reducer } from "redux";
import { connectRouter } from "connected-react-router";
import { History } from "history";
import reportsReducer from "./reportsReducer";
import { StoreType } from "../store";
import authReducer from "./authReducer";

export default (history: History): Reducer<StoreType> =>
  combineReducers<StoreType>({
    router: connectRouter(history),
    reports: reportsReducer,
    auth: authReducer,
  });
